<template>
  <div id="trivia">
    <section>
      <div class="container py-5">
        <div class="row py-4 text-center pt-5">

          <div class="col-12 pb-2 fXG blockd amarillo">MI CUENTA</div>

          <div class="col-12 text-center pt-5">
            <div class="row">
              <div class="col-md-6 fG blockd amarillo pb-5">
                <p class="blockd">Nombre:</p>
                <p>{{userProfile.nombre}}</p>
              </div>
              <div class="col-md-6 fG blockd amarillo pb-5">
                <p class="blockd">E-mail:</p>
                <p>{{getEmail}}</p>
              </div>
              <div class="col-md-6 fG blockd amarillo pb-5">
                <p class="blockd">Fecha de Nacimiento:</p>
                <p>{{fechaNacimiento}}</p>
              </div>
              <div class="col-md-6 fG blockd amarillo pb-5">
                <p class="blockd">Teléfono de Contacto:</p>
                <p>{{userProfile.celular}}</p>
              </div>
              <div class="col-md-6 fG blockd amarillo pb-5" v-if="userProfile.monedero != ''">
                <p class="blockd">Mi Monedero Inseparables:</p>
                <p>{{userProfile.monedero}}</p>
                <a class="small pointer" @click="toggleMonedero()">(editar)</a>
              </div>
            </div>
          </div>
        </div>

        <div class="row py-5" v-if="userProfile.monedero == ''">
          <div class="col-md-6 text-center pb-5">
            <a class="pb-5 pointer" @click="toggleMonedero()">
              <img
                class="pointer img-fluid btnaction zoom"
                src="../assets/imgs/interiores/agregar-monedero.png"
                alt="Agregar un Monedero Mi Inseparables"
              />
            </a>
          </div>
          <div class="col-md-6 text-center d-flex justify-content-center pb-5">
            <router-link class="pb-5" to="/mis-participaciones">
              <img
                class="pointer img-fluid btnaction zoominv"
                src="../assets/imgs/interiores/historial-participacion.png"
                alt="Historial de participación"
              />
            </router-link>
          </div>
        </div>
        <div class="row py-5" v-else>
          <div class="col-12 text-center d-flex justify-content-center pb-5">
            <router-link class="pb-5" to="/mis-participaciones">
              <img
                class="pointer img-fluid btnaction zoominv"
                src="../assets/imgs/interiores/historial-participacion.png"
                alt="Historial de participación"
              />
            </router-link>
          </div>
        </div>
      </div>
    </section>

    <MonederoSet v-if="showMonedero" @registro="registro" @close="showMonedero=false"></MonederoSet>

    <Footer></Footer>
  </div>
</template>

<script>
import { ticketsCollection } from "@/firebase";
import { mapState } from "vuex";
import moment from "moment";
import swal from "sweetalert2";

import * as fb from "../firebase";

import Footer from "@/components/Footer";
import MonederoSet from "@/components/MonederoSet";

export default {
  components: {
    Footer,
    MonederoSet
  },
  data() {
    return {
      post: {
        content: "",
      },
      showCommentModal: false,
      selectedPost: {},
      showPostModal: false,
      fullPost: {},
      postComments: [],
      file: null,
      monedero: "",
      isRunning: true,
      time: 0,
      time_txt: "",
      suma_puntos: 0,
      suma_time: 0,
      tickets2: [],
      tickets3: null,
      ultimo_ticket: {
        puntos: "",
        time: "",
        time_txt: "",
      },
      showMonedero:false,
      signupForm: {
        monedero: "",
      },
    };
  },
  computed: {
    ...mapState(["userProfile", "tickets"]),
    getEmail: function () {
      return fb.auth.currentUser.email;
    },
    fechaNacimiento: function () {
      return moment(this.userProfile.fecha_nacimiento).format("ll");
    },
  },
  mounted: function () {
  
  },
  methods: {
    toggleMonedero() {
      this.showMonedero = !this.showMonedero;
    },
    async registro(monedero = "") {
      if(monedero == ""){
         this.toggleMonedero()
         return 
      }
      

      this.monedero = monedero;
      console.log({ registromonedero: this.monedero })
      await this.$store.dispatch("registroMonedero", this.monedero)

      
      this.toggleMonedero()
    },
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }

      let date = val.toDate();
      return moment(date).fromNow();
    },
    trimLength(val) {
      if (val.length < 200) {
        return val;
      }
      return `${val.substring(0, 200)}...`;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
